import { render, staticRenderFns } from "./GroupGameInfoPayment.vue?vue&type=template&id=121baf7e&scoped=true&"
import script from "./GroupGameInfoPayment.vue?vue&type=script&lang=js&"
export * from "./GroupGameInfoPayment.vue?vue&type=script&lang=js&"
import style0 from "./GroupGameInfoPayment.vue?vue&type=style&index=0&id=121baf7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121baf7e",
  null
  
)

export default component.exports